import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import CartSheet from './components/CartSheet';
import AITravelPlanner from './components/AITravelPlanner';
import CallbackPopup from './components/CallbackPopup';
import HomePage from './pages/HomePage';
import ExplorePage from './pages/ExplorePage';
import PackageDetailsPage from './pages/PackageDetailsPage';
import PackagesPage from './pages/PackagesPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import VisaPage from './pages/VisaPage';
import CarRentalPage from './pages/CarRentalPage';
import TicketsPage from './pages/TicketsPage';
import AirportTransferPage from './pages/AirportTransferPage';

function App() {
  return (
    <BrowserRouter>
      <CartProvider>
        <div className="font-body">
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/explore" element={<ExplorePage />} />
            <Route path="/packages" element={<PackagesPage />} />
            <Route path="/packages/:id" element={<PackageDetailsPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/visa" element={<VisaPage />} />
            <Route path="/car-rental" element={<CarRentalPage />} />
            <Route path="/tickets" element={<TicketsPage />} />
            <Route path="/airport-transfer" element={<AirportTransferPage />} />
          </Routes>
          <Footer />
          <WhatsAppButton />
          <AITravelPlanner />
          <CallbackPopup />
          <CartSheet />
        </div>
      </CartProvider>
    </BrowserRouter>
  );
}

export default App;
